import React, { useEffect, useState } from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import locale from 'antd/es/date-picker/locale/pt_BR';
import '../main.css';
import { CustomCalendarIcon } from '../../../assets/icons/CalendarIcon';
import { handleConvertClasses } from './hooks/convertClasses';
dayjs.locale('pt-br');
const { RangePicker } = DatePicker;
export function RangePickerComponent({ toggleOverlay, onChange, hasError }) {
    const [selectedDates, setSelectedDates] = useState([null, null]);
    const disabledDate = (current) => {
        const tomorrowStart = dayjs().add(3, 'day').startOf('day');
        const oneYearFromNow = dayjs().add(1, 'year').endOf('day');
        if (current.isBefore(tomorrowStart)) {
            return true;
        }
        if (current.isAfter(oneYearFromNow)) {
            return true;
        }
        if (selectedDates[0] && current.isSame(selectedDates[0], 'day')) {
            return true;
        }
        return false;
    };
    const handleCalendarChange = (dates, dateStrings) => {
        const convertedDates = [
            dates[0] ? dayjs(dates[0]) : null,
            dates[1] ? dayjs(dates[1]) : null,
        ];
        setSelectedDates(convertedDates);
        if (convertedDates[0] && convertedDates[1]) {
            onChange(convertedDates, dateStrings);
        }
    };
    const handleChange = (dates, dateStrings) => {
        if (dates) {
            const convertedDates = [
                dates[0] ? dayjs(dates[0]) : null,
                dates[1] ? dayjs(dates[1]) : null,
            ];
            setSelectedDates(convertedDates);
            onChange(convertedDates, dateStrings);
        }
    };
    const formatWithCapitalization = (date) => {
        if (!date)
            return '';
        const formattedDate = date.format('ddd, DD MMM');
        return formattedDate.replace(/\b\w/g, char => char.toUpperCase());
    };
    useEffect(() => {
        if (selectedDates) {
            handleConvertClasses();
        }
    }, [selectedDates]);
    return (React.createElement(React.Fragment, null,
        React.createElement(RangePicker, { className: `custom-rangepicker ${hasError ? 'error' : ''}`, placeholder: ['Ida', 'Volta'], onFocus: () => toggleOverlay(true), onClick: (e) => e.stopPropagation(), suffixIcon: React.createElement(CustomCalendarIcon, { className: 'right-7 absolute top-6 text-black text-[16px]' }), value: selectedDates, format: formatWithCapitalization, allowClear: false, onChange: (dates, datesStrings) => {
                handleChange(dates, datesStrings);
            }, disabledDate: disabledDate, superNextIcon: false, superPrevIcon: false, locale: locale, onCalendarChange: (dates, datesStrings) => {
                handleCalendarChange(dates, datesStrings);
            } }),
        React.createElement(CustomCalendarIcon, { className: 'left-20 absolute top-6 text-black' })));
}
//# sourceMappingURL=index.js.map